import React from 'react';
import CreateExpense from './CreateExpense';
/* eslint-disable react/prop-types */

export default function GetExpenseForm({ data }) {
  return <CreateExpense data={data} />;
}
